import React from 'react'

const CheckBox = (props: any) => {
  const { register, errors, label } = props;
  return (
    <div className="w-full flex my-2 text-left relative mt-4">
      <input
        type='checkbox'
        {...register}
        className="focus:outline-none bg-[#EEF5F4] cursor-pointer"
      />
      <label htmlFor="" className='mx-2 '>
        {label}
      </label>

      {errors && (
        <p className="text-red-500 text-xs my-1">{errors?.message}</p>
      )}
    </div>
  )
}

export default CheckBox
